import React from 'react';
import { useTranslation } from 'react-i18next';
import journey1 from 'src/assets/img/journey_1.svg';
import journey2 from 'src/assets/img/journey_2.svg';
import journey3 from 'src/assets/img/journey_3.svg';
import journey4 from 'src/assets/img/journey_4.svg';
import { Button, Heading } from '@innovationnorway/cl-react';

const CustomerJourney: React.FC = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack-large">
      <Heading level={2}>{tHelpAndSupport('commonQuestions.Journey')}</Heading>
      <div className="stack-medium max-inline-size--60">
        <img className="margin-x--auto display--block" alt="hei" src={journey1}></img>
        <Heading level={3} className="font-weight--bold">
          {tHelpAndSupport('commonQuestions.Journey.Link.Header')}
        </Heading>
        <p>{tHelpAndSupport('commonQuestions.Journey.Link.Text')}</p>
      </div>
      <div className="stack-medium max-inline-size--60">
        <img className="margin-x--auto display--block" alt="hei" src={journey2}></img>
        <Heading level={3} className="font-weight--bold">
          {tHelpAndSupport('commonQuestions.Journey.Form.Header')}
        </Heading>
        <p>{tHelpAndSupport('commonQuestions.Journey.Form.Text')}</p>
      </div>
      <div className="stack-medium max-inline-size--60">
        <img className="margin-x--auto display--block" alt="hei" src={journey3}></img>
        <Heading level={3} className="font-weight--bold">
          {tHelpAndSupport('commonQuestions.Journey.Referred.Header')}
        </Heading>
        <p>{tHelpAndSupport('commonQuestions.Journey.Referred.Text')}</p>
        <p>{tHelpAndSupport('commonQuestions.Journey.Referred.Text2')}</p>
        <p>{tHelpAndSupport('commonQuestions.Journey.Referred.Text3')}</p>
        <Button
          type="button"
          variant="tertiary"
          onClick={() => {
            const sidebar = document.getElementsByClassName('drawer-side-menu__menu')[0];
            if (sidebar) {
              sidebar.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
            window.dispatchEvent(
              new CustomEvent('openSideMenu', {
                detail: 'index/commonQuestions/owi/invite',
              }),
            );
          }}
        >
          {tHelpAndSupport('commonQuestions.Journey.Referred.Link')}
        </Button>
      </div>
      <div className="stack-medium max-inline-size--60">
        <img className="margin-x--auto display--block" alt="hei" src={journey4}></img>
        <Heading level={3} className="font-weight--bold">
          {tHelpAndSupport('commonQuestions.Journey.MyPage.Header')}
        </Heading>
        <p>{tHelpAndSupport('commonQuestions.Journey.MyPage.Text')}</p>
      </div>
    </div>
  );
};

export default CustomerJourney;
